import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import HeaderActions from "../../../common/DasnboardHeader/HeaderActions";
import { styleBg } from "../../../common/Models/Validations";
import TicketTypesPanel from "./TicketTypesPanel";
import ExhibitionsPanel from "./panels/ExhibitionsPanel";
import RefundRequestsPanel from "./panels/RefundRequestsPanel";
import GuidesPanel from "./panels/GuidesPanel";
import PageWrapper from "../../../common/PageWrapper/PageWrapper";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`tm-tabpanel-${index}`} aria-labelledby={`tm-tab-${index}`} {...other}>
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `tm-tab-${index}`,
    "aria-controls": `tm-tabpanel-${index}`,
  };
}

export default function TicketManagementMain() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <PageWrapper>
      <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="ticket management tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            '& .MuiTabs-scrollable': {
              overflowX: 'auto !important',
            },
            '& .MuiTab-root': {
              minWidth: '100px !important',
              maxWidth: '200px !important',
              flexShrink: 0,
            },
          }}
        >
          <Tab label="TICKET Fee" {...a11yProps(0)} sx={{ ...styleBg(0, value) }} />
          <Tab label="EXHIBITIONS" {...a11yProps(1)} sx={{ ...styleBg(1, value) }} />
          <Tab label="GUIDES" {...a11yProps(2)} sx={{ ...styleBg(2, value) }} />
          <Tab label="REFUNDS" {...a11yProps(3)} sx={{ ...styleBg(3, value) }} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <TicketTypesPanel />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ExhibitionsPanel />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <GuidesPanel />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <RefundRequestsPanel />
      </CustomTabPanel>
    </PageWrapper>
  );
}
